import { Badge } from 'components/shared/Badge';
import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { getPublicPath } from 'utils/paths';
import {
  StyledContainer,
  StyledFeature,
  StyledFeatureContent,
  StyledFeatureImage,
  StyledTitleBadge
} from './ApplicationsFeatures.styled';

const ApplicationsFeatures: React.FC = () => {
  const { t } = useI18n('applications-landing');
  const { locale } = useRouter();

  return (
    <StyledContainer>
      <StyledFeature>
        <StyledFeatureImage>
          <img
            src={getPublicPath(
              `/images/applicationsLanding/${locale}/feature1.png`
            )}
            alt=""
          />
        </StyledFeatureImage>
        <StyledFeatureContent>
          <div>
            <Heading3 editorial>
              {t('applicationsLanding.features.experience.title')}
            </Heading3>
            <p
              dangerouslySetInnerHTML={{
                __html: t('applicationsLanding.features.experience.desc')
              }}
            ></p>
          </div>
          <div>
            <Heading3 editorial>
              {t('applicationsLanding.features.opportunities.title')}
              <br />
              <Badge variant="secondary" sizes="xs">
                {t('applicationsLanding.features.soon')}
              </Badge>
            </Heading3>
            <p
              dangerouslySetInnerHTML={{
                __html: t('applicationsLanding.features.opportunities.desc')
              }}
            ></p>
          </div>
        </StyledFeatureContent>
      </StyledFeature>
      <StyledFeature>
        <StyledFeatureContent>
          <div>
            <Heading3 editorial>
              {t('applicationsLanding.features.data.title')}
            </Heading3>
            <p
              dangerouslySetInnerHTML={{
                __html: t('applicationsLanding.features.data.desc')
              }}
            ></p>
          </div>
          <div>
            <StyledTitleBadge>
              <Heading3 editorial>
                {t('applicationsLanding.features.bias.title')}
                <br />
                <Badge variant="secondary" sizes="xs">
                  {t('applicationsLanding.features.soon')}
                </Badge>
              </Heading3>
            </StyledTitleBadge>
            <p
              dangerouslySetInnerHTML={{
                __html: t('applicationsLanding.features.bias.desc')
              }}
            ></p>
          </div>
        </StyledFeatureContent>
        <StyledFeatureImage>
          <img
            src={getPublicPath(
              `/images/applicationsLanding/${locale}/feature2.png`
            )}
            alt=""
          />
        </StyledFeatureImage>
      </StyledFeature>
    </StyledContainer>
  );
};

export default ApplicationsFeatures;
